























































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'
import SeletorDePessoa from '@/components/cliente/SeletorDePessoa.vue'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import RangerTimePicker from '@/components/ui/RangerTimePicker.vue'
import { FiltroDeVenda } from '@/models'
import { limparFiltroDosCamposDeVenda } from '@/shareds/venda-shareds'
import { nextTick } from '@/shareds/utils'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'

@Component({
	components: {
		RangeDatePicker,
		RangerTimePicker,
		SeletorDePessoa,
	},
})

export default class CamposDeFiltrosDeVendas extends Vue {
	@Prop({type: Boolean, default: false}) carregando!: boolean
	@PropSync('value',{
		default: () => ({
			busca: '',
			loja: '',
			datas: [],
			horas: [null, null],
			cliente: '',
			exibeVendasComErros: false,
			ambientes: '',
			vendasComOrcamento: false,
			vendasComPagamentoCancelado: false,
		}),
	}) filtro!: FiltroDeVenda
	mostra: boolean | null = null
	ambientes: string[] = []

	
	mostrar(){
		this.mostra = true
		if(this.exibirSomenteVendasDoPdvAtivo){
			const dataAberturaDoPdv = this.dataAbertura
			const horaAberturaDoPdv = this.horaAbertura

			this.filtro.datas = dataAberturaDoPdv
			this.filtro.horas = horaAberturaDoPdv
		}
	}

	ocultar(){
		this.mostra = false
	}

	limparFiltros(){
		if(this.exibirSomenteVendasDoPdvAtivo !== false){
			this.filtro.busca = ''
			this.filtro.cliente = ''
			this.filtro.exibeVendasComErros = false
			this.filtro.ambientes = [this.filtro.ambientes[0], this.filtro.ambientes[1]]
			this.filtro.vendasComOrcamento = false
			this.filtro.vendasComPagamentoCancelado = false
			this.$emit('buscar', this.filtro)
		}else{
			this.$emit('limpar')
			this.$emit('input', limparFiltroDosCamposDeVenda())
		}
		
	}

	@Watch('paginacao', { deep: true, immediate: true })
	onChangePaginacao(){
		this.$emit('buscar', this.filtro)
	}

	async aplicarFiltro() {
		await nextTick()
		this.$emit('buscar', this.filtro)
	}

	get exibirSomenteVendasDoPdvAtivo() {
		return UserLoginStore.permiteRegraDeNegocio('exibir-somente-vendas-do-pdv-ativo')
	}

	aberturaDoPdv(){
		if(this.exibirSomenteVendasDoPdvAtivo){
			return this.dataAbertura
		}
	}

	get pdvLogado() {
		return this.turnoDeVenda?.pontoDeVenda.ativo
	}

	get turnoDeVenda() {
		return VendaModule.turnoDeVenda
	}

	get dataAbertura(): [] | [string | null, string | null] {
		if (!this.turnoDeVenda) return []; 
		const abertura = this.movimentacaoDeAbertura;
		if (!abertura) return [];

		const dataHora = new Date(abertura.dataHoraMovimentacao);
		const dataFormatada = `${dataHora.getFullYear()}-${adicionaZeroAEsquerda(dataHora.getMonth() + 1)}-${adicionaZeroAEsquerda(dataHora.getDate())}`;

		return [dataFormatada, ''];
	}

	get horaAbertura(): [string | null, string | null] {
		if (!this.turnoDeVenda || !this.movimentacaoDeAbertura) {
			return [null, null]; 
		}
		
		const dataHora = new Date(this.movimentacaoDeAbertura.dataHoraMovimentacao);
		const horaFormatada = `${adicionaZeroAEsquerda(dataHora.getHours())}:${adicionaZeroAEsquerda(dataHora.getMinutes())}`;

		return [horaFormatada, ''];
	}

	get movimentacaoDeAbertura() {
		if (!this.turnoDeVenda) return ''
		return this.turnoDeVenda.movimentacoes.find(
			({ tipoMovimentacao }) => tipoMovimentacao === 'Abertura',
		)
	}
}

function adicionaZeroAEsquerda(num: number): string {
	return num < 10 ? `0${num}` : `${num}`;
}


